import type { ReactNode } from "react";

export function SettingsList({ children }: { children: ReactNode }) {
  return (
    <ul className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-lg divide-y divide-gray-200 dark:divide-gray-800">
      {children}
    </ul>
  );
}

interface ItemProps {
  title: ReactNode;
  meta?: ReactNode;
  action?: ReactNode;
}

export function SettingsListItem({ title, meta, action }: ItemProps) {
  return (
    <li className="flex items-center gap-3 px-4 py-3">
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-gray-900 dark:text-white break-words">{title}</div>
        {meta && <div className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">{meta}</div>}
      </div>
      {action && <div className="shrink-0 flex flex-wrap items-center justify-end gap-2">{action}</div>}
    </li>
  );
}
